export const AUTH = {
  createAccountButton: "welcome-create-account-button",
  googleButton: "welcome-google-button",
  signInButton: "welcome-signin-button",
};

export const LOGIN = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitButton: "login-submit-button",
  registerLink: "login-register-link",
  googleButton: "login-google-button",
  error: "login-error",
};

export const REGISTER = {
  nameInput: "register-name-input",
  emailInput: "register-email-input",
  passwordInput: "register-password-input",
  submitButton: "register-submit-button",
  loginLink: "register-login-link",
  googleButton: "register-google-button",
  error: "register-error",
};

export const ONBOARDING = {
  goalOption: "onboarding-goal-option",
  stageOption: "onboarding-stage-option",
  rhythmOption: "onboarding-rhythm-option",
  faithToggle: "onboarding-faith-toggle",
  nextButton: "onboarding-next-button",
  backButton: "onboarding-back-button",
  finishButton: "onboarding-finish-button",
  skipButton: "onboarding-skip-button",
};

export const NAV = {
  home: "nav-home",
  learn: "nav-learn",
  coach: "nav-coach",
  journal: "nav-journal",
  community: "nav-community",
  plans: "nav-plans",
  wellness: "nav-wellness",
  progress: "nav-progress",
  tools: "nav-tools",
  resources: "nav-resources",
  settings: "nav-settings",
  upgrade: "nav-upgrade",
  logout: "nav-logout-button",
  mobileMenu: "nav-mobile-menu-button",
};

export const COMMUNITY = {
  circleCard: "community-circle-card",
  backButton: "community-back-button",
  composerInput: "community-composer-input",
  anonymousToggle: "community-anonymous-toggle",
  postButton: "community-post-button",
  postCard: "community-post-card",
  likeButton: "community-like-button",
  commentToggle: "community-comment-toggle",
  commentInput: "community-comment-input",
  commentSubmit: "community-comment-submit",
  reportButton: "community-report-button",
  blockButton: "community-block-button",
  deleteButton: "community-delete-button",
};

export const PLANS = {
  planCard: "plans-plan-card",
  enrollButton: "plans-enroll-button",
  dayItem: "plans-day-item",
  backButton: "plans-back-button",
};

export const HOME = {
  recommendation: "home-recommendation-card",
  startRecommendation: "home-start-recommendation-button",
  promptCard: "home-prompt-card",
  coachShortcut: "home-coach-shortcut",
  wellnessSnapshot: "home-wellness-snapshot",
};

export const LEARN = {
  categoryCard: "learn-category-card",
  lessonCard: "learn-lesson-card",
  searchInput: "learn-search-input",
  backButton: "learn-back-button",
  bookmarksTab: "learn-bookmarks-tab",
};

export const LESSON = {
  completeButton: "lesson-complete-button",
  bookmarkButton: "lesson-bookmark-button",
  backButton: "lesson-back-button",
};

export const COACH = {
  input: "coach-input",
  sendButton: "coach-send-button",
  promptPill: "coach-prompt-pill",
  message: "coach-message",
};

export const JOURNAL = {
  newButton: "journal-new-button",
  titleInput: "journal-title-input",
  bodyInput: "journal-body-input",
  saveButton: "journal-save-button",
  entryCard: "journal-entry-card",
  deleteButton: "journal-delete-button",
  promptChip: "journal-prompt-chip",
};

export const WELLNESS = {
  slider: "wellness-slider",
  noteInput: "wellness-note-input",
  saveButton: "wellness-save-button",
  chart: "wellness-chart",
};

export const PAYWALL = {
  monthlyPlan: "paywall-monthly-plan",
  annualPlan: "paywall-annual-plan",
  subscribeButton: "paywall-subscribe-button",
  paypalContainer: "paywall-paypal-container",
  closeButton: "paywall-close-button",
};

export const PROGRESS = {
  page: "progress-page",
  milestone: "progress-milestone",
};

export const NOTIF = {
  bell: "notif-bell-button",
  badge: "notif-unread-badge",
  page: "notifications-page",
};

export const MODERATION = {
  page: "moderation-page",
  navLink: "nav-moderation",
};

export const AFFIRMATION = {
  card: "affirmation-card",
  save: "affirmation-save-button",
  share: "affirmation-share-button",
  viewSaved: "affirmation-view-saved",
  page: "affirmations-page",
};

export const TOOLS = {
  page: "tools-page",
  card: "tools-card",
  groundingNext: "tools-grounding-next",
  stepNext: "tools-step-next",
  gratitudeSave: "tools-gratitude-save",
};
